import { useQuery } from "react-query";
import API from "../../../services/API";
import { useContext } from "react";
import UserContext from "../../../services/Context/UserContext";

export default function useRewards(){

    const { user } = useContext(UserContext)

    return useQuery({

        queryKey: ['rewards', user?.id],

        queryFn: () => user ? API.get(`/rewards`).then(r => r.data) : [],

    })
}